export { createPrediction } from './CreatePredictionAction';
export {
  CONNECT_MARKET,
  UPDATE_MARKET,
  connectMarket,
  updateDynamicMarketData
} from './ConnectMarketAction';
export { GET_PREDICTION_PREVIEW, getPredictionPreview } from './GetPredictionPreviewAction';



// WEBPACK FOOTER //
// ./src/market/actions/index.js